import fetchJson from '@xingternal/malt-network/fetch-json';

import messages from './messages';

import { JSON_HEADERS } from './constants';

const validateLogin = values => {
  const { usernameRequiredError, passwordRequiredError } = messages;
  const errors = {};

  if (values.username.trim() === '') errors.username = usernameRequiredError;
  if (values.password.trim() === '') errors.password = passwordRequiredError;

  return errors;
};

const createLogin = (externalLoginUrl, values, retries = 2) => {
  return loginRequest(externalLoginUrl, values)
    .then(result => result)
    .catch(error => {
      if (retries === 1) throw error;

      // skip retry for wrong credentials
      const status = error.response && error.response.status;
      if (status <= 401) throw error;

      return createLogin(externalLoginUrl, values, retries - 1);
    });
};

const loginRequest = (externalLoginUrl, values) =>
  fetchJson(`${externalLoginUrl}/login/api/login`, {
    headers: JSON_HEADERS,
    method: 'POST',
    mode: 'cors',
    credentials: 'include',
    body: JSON.stringify(values),
  }).then(({ success, target }) => {
    if (!success) throw Error;
    return new Promise(() => {
      window.location = target;
    });
  });

export { validateLogin, createLogin };
